import { COLOR_OPTIONS, type IColor } from '@/constants/color.options';

export function useColorHelper(): {
    getColor: (value: string) => IColor;
    getColorName: (value: string, archived?: boolean) => string;
    getLightColorName: (value: string) => string;
    getTagColorName: (value: string) => string;
    getTagColorLabel: (value: string) => string;
} {
    function filterColor(colorArray: IColor[], value: string): IColor[] {
        return colorArray.filter((colorOption) => {
            return colorOption.oldValue?.includes(value) || colorOption.oldColor?.includes(value) || colorOption.value === value || colorOption.color === value;
        });
    }

    function getColor(value: string): IColor {
        const matchingColor = filterColor(COLOR_OPTIONS.DEFAULT, value);
        return matchingColor.length > 0 ? matchingColor[0] : COLOR_OPTIONS.DEFAULT[0];
    }

    function getColorName(value: string, archived?: boolean): string {
        if (archived) {
            return 'grey';
        }
        const matchingColor = filterColor(COLOR_OPTIONS.DEFAULT, value);
        return matchingColor.length > 0 ? matchingColor[0].color : 'grey-dark';
    }

    function getLightColorName(value: string): string {
        const matchingColor = filterColor(COLOR_OPTIONS.DEFAULT, value);
        return matchingColor.length > 0 ? matchingColor[0].lightColor : 'white';
    }

    function getTagColorName(value: string): string {
        const matchingColor = filterColor(COLOR_OPTIONS.TAG, value.toLowerCase().trim());
        return matchingColor.length > 0 ? matchingColor[0].color : 'grey-dark';
    }

    function getTagColorLabel(value: string): string {
        const matchingColor = filterColor(COLOR_OPTIONS.TAG, value.toLowerCase().trim());
        return matchingColor.length > 0 ? matchingColor[0].label : 'Unknown';
    }

    return { getColor, getColorName, getLightColorName, getTagColorName, getTagColorLabel };
}
